import { render, staticRenderFns } from "./PaymentsArchive.vue?vue&type=template&id=f473e344&scoped=true"
import script from "./PaymentsArchive.vue?vue&type=script&lang=js"
export * from "./PaymentsArchive.vue?vue&type=script&lang=js"
import style0 from "./PaymentsArchive.vue?vue&type=style&index=0&id=f473e344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f473e344",
  null
  
)

export default component.exports